import { createSelector } from "@reduxjs/toolkit";

const getState = (state) => state.dropedField;

export const getAuthorization = createSelector(
  getState,
  (state) => state?.loginData ?? []
);
